import { useState } from "react";
import { cdName } from "../lib/filename";
import { toast } from "sonner";
import { Download, Send } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const prevMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return d.toISOString().slice(0, 7); };

export const AccountingExportDialog = ({ open, onClose }) => {
  const [month, setMonth] = useState(prevMonth());
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState("");
  const dl = async (fmt) => {
    setBusy(fmt);
    try {
      const r = await http.get("/superadmin/accounting/export", { params: { month, fmt }, responseType: "blob" });
      const name = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || `export.${fmt}`;
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = cdName(r.headers["content-disposition"], name); a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  const send = async () => {
    setBusy("send");
    try { const { data } = await http.post("/superadmin/accounting/send", { month, to: to || null }); toast.success(`Export envoyé à ${data.to}`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  const btn = "inline-flex items-center gap-1.5 px-3 py-2 text-sm rounded-md border border-slate-300 font-semibold hover:border-slate-900 transition-colors disabled:opacity-50";
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="accounting-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Export comptable</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">Factures et avoirs XALTIX émis sur le mois choisi.</p>
        <label className="block text-sm font-semibold">Mois<input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2" data-testid="accounting-month" /></label>
        <div className="flex flex-wrap gap-2">
          <button disabled={!!busy} onClick={() => dl("xlsx")} className={btn} data-testid="accounting-dl-xlsx"><Download className="h-4 w-4" />Excel</button>
          <button disabled={!!busy} onClick={() => dl("csv")} className={btn} data-testid="accounting-dl-csv"><Download className="h-4 w-4" />CSV</button>
          <button disabled={!!busy} onClick={() => dl("fec")} className={btn} data-testid="accounting-dl-fec"><Download className="h-4 w-4" />FEC</button>
        </div>
        <div className="border-t border-slate-100 pt-3">
          <label className="block text-sm font-semibold">Envoyer à<input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="Vide = e-mail de l'expert-comptable (Paramètres)" className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2" data-testid="accounting-to" /></label>
          <button disabled={!!busy} onClick={send} className="mt-2 inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-md bg-slate-900 text-white font-semibold disabled:opacity-50" data-testid="accounting-send"><Send className="h-4 w-4" />{busy === "send" ? "Envoi…" : "Envoyer les 3 fichiers par e-mail"}</button>
          <p className="text-[11px] text-slate-500 mt-2">L'envoi automatique le 1er de chaque mois se règle dans Paramètres › Conditions de vente.</p>
        </div>
        <div className="flex justify-end"><button onClick={onClose} className="px-4 py-2 text-sm rounded-md border border-slate-300" data-testid="accounting-close">Fermer</button></div>
      </DialogContent>
    </Dialog>
  );
};
